import { send_to_server } from '@/services/socketio_client_react/send_to_server';
import { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import { ENUM__network_event_client_to_server } from '@shared/network/ENUM__network_event_client_to_server';
import { createAsyncThunkSafe } from '../../_base/createAsyncThunkSafe';
import { StateUser } from '../state_user';

export const remote_user_settings_update_name = createAsyncThunkSafe<string, string>(
  ENUM__network_event_client_to_server.USER_SETTINGS_UPDATE_USER_NAME,
  async (name): Promise<string> => {
    let response = await send_to_server<string>(ENUM__network_event_client_to_server.USER_SETTINGS_UPDATE_USER_NAME, name);
    return response;
  },
);

export function init_remote_user_settings_update_name(builder: ActionReducerMapBuilder<StateUser>) {
  builder
    .addCase(remote_user_settings_update_name.pending, state => {})
    .addCase(remote_user_settings_update_name.rejected, (state, action) => {})
    .addCase(remote_user_settings_update_name.fulfilled, (state, action: PayloadAction<string>) => {
      state.user_full_name = action.payload;
    });
}
